var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('NavBar'):_vm._e(),_c('Alert',{attrs:{"alertService":_vm.alertService}}),(_vm.loadingSpinnerService.isLoading)?_c('loading-spinner',{attrs:{"fullScreen":true}}):_vm._e(),_c('router-view',{staticClass:"p-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }